




























































import { Component, Vue, Watch } from 'vue-property-decorator';
import DragableList from './DragableList.vue';
import { TableFiltersModule } from '../store/tableFilters';
import api from '@/api'

@Component({
    name: 'SortTableFiltersDlg',
    components: {
        DragableList
    }
})
export default class extends Vue {

    get filtersObj() {
        return TableFiltersModule.tableFiltersObjCopy[TableFiltersModule.sortFiltersDialogTableName];
    }

    get filtersArr() {
        const arr: any[] = [];
        this.filtersObj && Object.keys(this.filtersObj).forEach(key => {
            if (this.filtersObj[key].checked) {
                arr.push(this.filtersObj[key]);
            }
        });
        arr.sort((a, b) => a.index - b.index);
        if(arr.length === 1){
            arr[0]['disabled'] = true
        }else{
            arr.map(item=>{
                item['disabled'] = false
            })
        }
        return arr;
    }


    get dialogVisible() {
        return TableFiltersModule.showTableFiltersDialog;
    }

    set dialogVisible(val) {}

    // 左列所有字段的数量 跟ui确认过的
    get optionalCounts() {
        let count = 0;
        this.filtersObj && Object.keys(this.filtersObj).forEach(key => {
            if (key !== 'judgeList') {
                count++
            }
        });
        return count;
    }

    @Watch('dialogVisible')
    onVisibleChange(newVal) {
        if(newVal){
            this.$nextTick(()=>{
                const targetElement = document.querySelector('.mainBox');
                this.scrollToTop(targetElement);
            })
        }
    }

    private handleChange(obj) {
        obj.checked = !obj.checked;
        this.hideCurrent(obj);
    }

    // 回到默认设置
    private defaultSetting() {
        TableFiltersModule.RESTORE_DEFAULT_SETTINGS();
    }

    private handleOkBtn() {
        // 更新数据
        TableFiltersModule.UPDATE_FILTERS_STATE(this.filtersObj);
        api.save_table_filters_config({
            tableName: TableFiltersModule.sortFiltersDialogTableName,
            configJson: JSON.stringify(this.filtersObj)
        });
        TableFiltersModule.CLOSE_SORT_FILTERS_DLG();
    }

    // 关闭窗口
    private handleCancelBtn() {
        TableFiltersModule.CLOSE_SORT_FILTERS_DLG();
    }

    private hideCurrent(row) {
        let label = '';
        Object.keys(this.filtersObj).forEach(key => {
            if (this.filtersObj[key].label === row.label && this.filtersObj[key].index === row.index) {
                label = key;
            }
        });
        const data = {
            name: TableFiltersModule.sortFiltersDialogTableName,
            label
        };
        TableFiltersModule.CHANGE_CHECKED_STATUS(data)
    }

    private scrollToTop(element) {
        element.scrollTo({
            top: 0,
            behavior: 'smooth' // 使用平滑滚动效果
        });
    }

}
